"use strict";

export default class {
    constructor(dataObject = null) {
        this.Id = 0;
        this.Code = '';
        this.Name = '';
        this.CountryCode = '';

        if (dataObject) {
            try {
                this.Id = dataObject.Id ?? dataObject.id ?? 0;
                this.Code = dataObject.Code ?? dataObject.code ?? '';
                this.Name = dataObject.Name ?? dataObject.name ?? '';
                this.CountryCode =
                    dataObject.CountryCode ?? dataObject.countryCode ?? '';
            } catch (e) {
                throw 'Data import error @ StateMaster data.';
            }
        }
    }
}
